<!-- Chatbot Interaction Page -->
<div class="h-full p-8">
  <!-- Header -->
  <div class="mb-8">
    <app-page-header
      title="Chatbots Asignados"
      subtitle="Gestiona y accede a tus chatbots asignados"
    ></app-page-header>
  </div>

  <!-- Search Bar -->
  <div class="mb-8 max-w-md">
    <app-search-input
      [value]="searchQuery"
      (valueChange)="searchQuery = $event"
      placeholder="Buscar chatbots..."
      [disabled]="loading()"
    ></app-search-input>
  </div>

  <!-- Loading State -->
  @if (loading()) {
    <app-loading-spinner message="Cargando chatbots..." [size]="48"></app-loading-spinner>
  }

  <!-- Error State -->
  @if (error() && !loading()) {
    <app-empty-state
      [title]="error()!"
      message=""
      emoji="⚠️"
    >
      <button
        (click)="loadChatbots()"
        class="mt-4 px-6 py-2 bg-light-primary dark:bg-dark-primary text-white rounded-xl hover:opacity-80 transition-opacity">
        Reintentar
      </button>
    </app-empty-state>
  }

  <!-- Chatbot Cards Grid -->
  @if (!loading() && !error()) {
    <app-chatbot-card-grid
      [chatbots]="filteredChatbots"
      avatarStyle="gradient"
      [showCode]="true"
      (selectChatbot)="selectChatbot($event)"
    ></app-chatbot-card-grid>

    <!-- Empty State -->
    @if (filteredChatbots.length === 0 && !loading()) {
      <app-empty-state
        [icon]="Bot"
        title="No se encontraron chatbots"
        [message]="searchQuery ? 'Intenta ajustar tus términos de búsqueda' : 'No tienes chatbots asignados'"
      ></app-empty-state>
    }
  }
</div>
